<template>
  <div class="course-add-or-update">
    <el-dialog
      :title="courseQuery.id == 0 ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="courseDialogVisile"
      @close="courseDialogClose"
    >
      <el-form
        ref="coursesRef"
        :model="courseQuery"
        :rules="courseRules"
        label-width="80px"
        @keyup.enter.native="newsSubmit()"
      >
        <el-form-item label="标题" prop="title">
          <el-input
            v-model="courseQuery.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="author">
          <el-input
            v-model="courseQuery.author"
            placeholder="请输入作者"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="videoType">
          <el-select
            v-model="courseQuery.videoType"
            placeholder="请选择活动区域"
          >
            <el-option label="电商运营" value="0"></el-option>
            <el-option label="电子商务法" value="1"></el-option>
            <el-option label="商务活动" value="2"></el-option>
            <el-option label="共享培训课件" value="3"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            :rows="3"
            v-model="courseQuery.description"
            placeholder="请输入描述信息"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="来源" prop="origin">
          <el-input
            v-model="courseQuery.origin"
            placeholder="请输入来源"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="courseQuery.sort"
            controls-position="right"
            :min="0"
            size="small"
          ></el-input-number> </el-form-item
        ><el-form-item label="课程图片">
          <!-- 图片上传组件 -->
          <img-upload
            @imgUploaded="imgUploaded"
            @removeImg="removeImg"
            :imgList="preImg"
          />
        </el-form-item>
        <el-form-item label="视频文件">
          <video-upload
            ref="videoUploaded"
            @videoUploaded="videoUploaded"
            @removeVideo="removeVideo"
            :videoList="preVideo"
          />
        </el-form-item>
        <el-form-item label="视频链接" >
          <el-input
            v-model="courseQuery.video"
            placeholder="请输入视频链接"
            @input="isHaveVideo"
          ></el-input>
        </el-form-item>
           <el-form-item label="跳转链接" >
          <el-input
            v-model="courseQuery.link"
            placeholder="请输入视频外部跳转链接"
            @input="isHaveVideo"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="newsSubmit">提交</el-button>
          <el-button @click="courseDialogVisile = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ImgUpload from "@/views/modules/config/child-components/upload-img";
import { showcontent } from "@/utils/method.js";
import VideoUpload from "@/views/modules/config/child-components/upload-video";
export default {
  components: {
    ImgUpload,
    VideoUpload,
  },
  data() {
    return {
      // 控制修改/添加课程弹出框的显示与隐藏
      courseDialogVisile: false,
      // 课程修改/添加参数
      courseQuery: {
        id: null,
        title: "",
        author: "",
        description: "",
        origin: "",
        sort: 0,
        thumb: "",
        video: "",
         link:'',
        videoType: "",
      },
      // 上传图片的组件要显示的图片
      preImg: [],
      // 上传视频的组件要现实的视频
      preVideo: [],
      // 表单验证规则
      courseRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        videoType: [{ required: true, message: "请选择类型", trigger: "blur" }],
        video: [{ required: true, message: "请填写视频链接", trigger: "blur" }],
        link: [{ required: true, message: "请填写视频链接", trigger: "blur" }],
      },
    };
  },
  methods: {
    showcontent,
    init(id) {
      this.courseDialogVisile = true;
      this.courseQuery.id = id || 0;
      if (this.courseQuery.id) {
        this.$ajaxGet(`/course/info/open/${this.courseQuery.id}`).then(
          ({ data }) => {
            console.log("@", data);
            if (data.code === 0) {
              // let dataa = JSON.stringify(data.data);
              // this.courseQuery = JSON.parse(
              //   // dataa
              //   showcontent(dataa)
              // );
              // data.data.content = showcontent(data.data.content);
              // data.data.description = showcontent(data.data.description);
              data.data.origin = showcontent(data.data.origin);
              data.data.author = showcontent(data.data.author);
              data.data.title = showcontent(data.data.title);
              this.courseQuery = data.data;
              // this.courseQuery = showcontent( JSON.parse( data.data));
              this.preImg = [{ name: "课程图片", url: this.courseQuery.thumb }];
              this.preVideo = [
                { name: "课程视频", url: this.courseQuery.video },
              ];
            }
          }
        );
      }
    },
    // 点击提交按钮
    newsSubmit() {
      // debugger
      console.log(this.courseQuery.video);
      // if(this.courseQuery.video.indexOf('mp4') ==-1){
      //   this.$message('视频链接错误！')
      //   return
      // }
      this.$refs.coursesRef.validate((valid) => {
        if (valid) {
          // 添加课程时不能传id并且要传showStatus字段
          let courses = {};
          courses = { ...this.courseQuery };
          if (this.courseQuery.id === 0) {
            delete courses.id;
            courses.showStatus = "0";
          }
          this.$ajaxPost(
            `/course/${this.courseQuery.id === 0 ? "save" : "update"}`,
            courses
          ).then(({ data }) => {
            if (data.code === 0) {
              this.$emit("courseListUpdate");
              this.courseDialogVisile = false;
              this.$message.success(
                `${this.courseQuery.id === 0 ? "添加成功!" : "更新成功!"}`
              );
            }
          });
        } else {
          return false;
        }
      });
    },
    // 图片上传完成
    imgUploaded(url) {
      this.courseQuery.thumb = url;
    },
    removeImg() {
      this.courseQuery.thumb = "";
    },
    // 视频上传完成
    videoUploaded(url) {
      if (this.courseQuery.video != "") {
        this.$refs.videoUploaded.clearFiles();
        this.$message({
          title: "错误",
          type: "error",
          message: "视频外链已上传，请删除后选择文件上传",
        });
      } else {
        this.courseQuery.video = url;
      }
    },
    // 移除上传的视频
    removeVideo() {
      this.courseQuery.video = "";
    },
    isHaveVideo() {
      console.log(this.courseQuery.video);
      if (this.courseQuery.video != "") {
        // this.$message({
        //   title: "错误",
        //   type: "error",
        //   message: "视频外链已上传，请删除后选择文件上传",
        // });
      }
    },
    // 关闭对话框触发事件
    courseDialogClose() {
      this.$refs.coursesRef.resetFields();
      Object.keys(this.courseQuery).forEach((item) => {
        if (item === "id") {
          this.courseQuery[item] = null;
        } else if (item === "sort") {
          this.courseQuery[item] = 0;
        } else {
          this.courseQuery[item] = "";
        }
      });
      this.preImg = [];
      this.preVideo = [];
    },
  },
};
</script>

<style lang="less" scoped>
</style>